import { Component, EventEmitter, HostListener, OnInit, ViewChild, Output, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { takeWhile } from 'rxjs/operators';
import { BaseService, SettingsService, StorageService } from 'src/app/core/services';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { PaymentService } from 'src/app/core/services/payment.service';
import { PlanService } from 'src/app/core/services/plan.service';
import { SessionService } from 'src/app/core/services/session.service';
import { SubscriptionService } from 'src/app/core/services/subscription.service';
import { IdealPayComponent } from 'src/app/shared/components/ideal-pay/ideal-pay.component';
import { COUPON } from '../../constants';
import { R_ACCOUNT_SETTINGS } from 'src/app/shared/constants/route.constants';
import { environment } from 'src/environment';
import { StripeInfoComponent } from '../stripe-info/stripe-info.component';
import { ApplicationService } from 'src/app/core/services/application.service';
import { AdyenCheckout, Redirect } from '@adyen/adyen-web';
import { CoreConfiguration } from '@adyen/adyen-web';
@Component({
  selector: 'app-ideal-payment-bank',
  templateUrl: './ideal-payment-bank.component.html',
  styleUrls: [`./ideal-payment-bank.component.scss`],
  standalone: true,
  imports: [StripeInfoComponent, IdealPayComponent]
})
export class IdealPaymentBankComponent implements OnInit {

  homeImage = '';
  indexPage = false;
  headAmount = false;
  authHead = '';
  backRoute = 'auth/plan';
  currentStep = 4;
  uId = '';
  region = '';
  locale = '';
  proceedToPay = false;
  errorFound: any;
  errorResult;
  subsId = '';
  fingerprint_checked;
  stripe_fingerprint;
  idealEmptyError;
  private errRoute = '/auth/payment/error';
  @ViewChild(IdealPayComponent) idealData: IdealPayComponent;
  backButton = false;
  livePage: any;
  paymentProcessCheckAlive = true;
  @Output() emitIdealPayment = new EventEmitter<{ session_id: string }>();
  @Input() enableIdealPayment;
  skinName = environment.skinName;
  paymentGateway: any;
  adyenIdealActions: any;

  constructor(private baseService: BaseService, private settingsService: SettingsService,
    public subscriptionService: SubscriptionService, public configService: ConfigurationService,
    public planService: PlanService, private storageService: StorageService, private route: ActivatedRoute,
    private sessionService: SessionService, private paymentService: PaymentService, private settingService: SettingsService,
    private applicationService: ApplicationService, private router: Router) {
    const querydata = this.route.snapshot.queryParams;
    const couponMapData = this.route.snapshot.params?.coupon_valid;
    this.backRoute = `/auth/method?session_id=${querydata['session_id']}`;
    const discountCoupon = this.storageService.getLocalStore('discount_code');
    const discountType = this.storageService.getLocalStore('discount_type');
    if (discountCoupon && discountType) this.backRoute = `/voucher/method/${couponMapData}?session_id=${querydata['session_id']}`;
    this.authHead = configService.localeKeys?.sign_up_title_sign_up_def || 'Sign up';
  }

  ngOnInit(): void {
    this.paymentGateway = this.settingsService.paymentGateway;
    this.baseService.loaderSource.next(false);
    if (this.planService.plansLength > 0) {
      if (!this.subscriptionService.subsData) {
        this.subscriptionService.userPlan().subscribe()
      }
    }
    const querydata = this.route.snapshot.queryParams;
    this.livePage = this.router.url.match('/live/');
    if (querydata['session_id']) {
      this.subscriptionService.paymentSessionId = querydata['session_id'];
    }
    this.uId = this.storageService.getLocalStore('u_id');
    this.region = this.storageService.getLocalStore('region');
    this.locale = this.storageService.getLocalStore('locale');
    if (this.paymentGateway === 'adyen') {
    this.createAdyenCheckout();
    } else {
      this.validateSession();
    }  
  }

  validateSession() {
    this.sessionService.validateSession(this.subscriptionService.paymentSessionId).subscribe((resp) => {
      if (resp.status_code === 200) {
        const data = resp.data;
        this.subsId = data.session?.subscription_id;
        this.paymentService.paymentMethodLength = data.stripe_payment_methods.length;
        this.errorFound = (data.already_subscribed || data.expired || data.invalid);
        this.errorResult = {
          already_subscribed: data.already_subscribed, expired: data.expired, invalid: data.invalid
        };
        if (this.errorFound) {
          this.baseService.loaderSource.next(false);
          this.navErrPage();
        }
      } else {
        this.errorResult = {
          already_subscribed: false, expired: false, invalid: true
        };
        this.navErrPage();
        this.baseService.loaderSource.next(false);
      }
    })
  }

  navErrPage() {
    switch (true) {
      case (this.errorResult.already_subscribed):
        this.router.navigate([`${this.errRoute}`, 'susbcribed']);
        break;
      case (this.errorResult.expired):
        this.router.navigate([`${this.errRoute}`, 'expired']);
        break;
      case (this.errorResult.invalid):
        this.router.navigate([`${this.errRoute}`, 'invalid']);
        break;
      default:
        this.router.navigate([`${this.errRoute}`, 'invalid']);
        break;
    }
  }

  proceedPayment() {
    const user = this.subscriptionService.planDetails?.user || this.subscriptionService.userDetails;
    this.baseService.loaderSource.next(true);
    const createSubsObj = {
      session_id: this.subscriptionService.paymentSessionId,
      locale: this.locale,
      region: this.region,
      name: user?.name,
      email: user?.email
    };
    this.idealData.proceedPayment = true;
    if (!this.idealData?.idealEmptyError) {
      if (this.router.url == R_ACCOUNT_SETTINGS || this.livePage?.length > 0) {
        this.storageService.setLocalStore('ideal_pay_redirect', this.router.url);
      }
      const discountCoupon = this.storageService.getLocalStore('discount_code');
      const discountType = this.storageService.getLocalStore('discount_type');
      if (discountCoupon && discountType === COUPON) {
        createSubsObj['coupon_code'] = discountCoupon;
      }
      const redirectPage = (discountType === COUPON && discountCoupon) ?
        '/voucher/payment/in-progress' : '/auth/payment/in-progress';
      this.paymentService.idealPayItem(createSubsObj, redirectPage);
    } else this.baseService.loaderSource.next(false);
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.backButton = true;
    this.baseService.paymentProcessing
      .pipe(takeWhile(() => this.paymentProcessCheckAlive))
      .subscribe((value) => {
        if (value && this.backButton) {
          this.paymentService.showAlertBox();
          if (history?.state !== null) {
            history.pushState(null, document.title, location.href);
          }
          this.backButton = false;
        } else if (!value && this.backButton) {
          this.backButton = false;
          const prevPaymentPathName = this.storageService.getLocalStore('prevPaymentPathName');
          const querydata = this.route.snapshot.queryParams;
          const backRoute = `/auth/method?session_id=${querydata['session_id']}`;
          location.href = prevPaymentPathName ? prevPaymentPathName : backRoute;
        }
      });
  }

  async createAdyenCheckout() {
    const clientKey = this.settingService.adyenCleintKey;
    const locale = this.storageService.getLocalStore('locale');
    const countryCode = this.storageService.getLocalStore('country_code');
    const userSelectedPlan = this.storageService.getSessionStore('selectedPlanData');
  
    const configuration: CoreConfiguration = {
      environment: this.settingService.adyenEnvironment,
      clientKey: clientKey,
      locale: locale,
      countryCode: countryCode,
      amount: {
        value: userSelectedPlan.amount,
        currency: this.applicationService.currencyPrefixSuffix.prefix + this.applicationService.currencyPrefixSuffix.suffix
      },
      paymentMethodsResponse: this.subscriptionService.adyenPaymentMethods,
      onSubmit: async (state, component, actions) => {
        this.adyenIdealActions = actions;
        const reqObj = await this.subscriptionService.prepareAdyenRequestData(state, userSelectedPlan.pricing_plan_id, this.subscriptionService.paymentSessionId);
        this.createAdyenIdeal(reqObj);
      },
      onPaymentCompleted(result, component) {
        const paymentResult: any = result;
        this.adyenIdealActions.resolve({
            resultCode: paymentResult?.resultCode,
            action: paymentResult?.action,
            order: paymentResult?.order
        });
      },
      onPaymentFailed(result, component) {
        this.adyenIdealActions.reject();
      },
      onError(error) {
        this.adyenIdealActions.reject();
      }
    };

    const discountCoupon = this.storageService.getLocalStore('discount_code');
    const discountType = this.storageService.getLocalStore('discount_type');
    if (discountCoupon && discountType === COUPON) {
      configuration.amount.value = userSelectedPlan.payable_amount;
    }
    const checkout = await AdyenCheckout(configuration);
    const ideal = new Redirect(checkout, { type: 'ideal' }).mount('#adyen-ideal-container');
  }
  createAdyenIdeal(reqObj) {
    this.subscriptionService.createSubcription(reqObj).subscribe(
      (resp) => {
        if (resp?.action?.type === 'redirect') {
          window.open(resp.action.url, '_self');
        } else {
          this.adyenIdealActions.reject();
        }
      }, err => {
        // getting new session when the payment is failed
        this.subscriptionService.getNewSessionId().then(sessionId => {
          this.subscriptionService.paymentSessionId = sessionId;
        }).catch(error => {
          console.error('Error:', error);
        });
        this.adyenIdealActions.reject();
      });
  }
}
